module.exports = __webpack_public_path__ + "static/media/concorde.3eb41fc5.png";